<template>
    <div class="o-page__inner"
        :data-component-name="$options.name"
    >
        <form class="o-form" @submit.prevent="updateMyUserProfile(form)"
            :class="{'-two-columns': !isMobile}"
        >
			<div class="o-page__loading" v-if="$apollo.loading">
                <q-spinner
                    color="white"
                    size="1em"
                />
                Chargement en cours
            </div>
            <fieldset class="o-form__inner" v-if="!$apollo.loading">
                <h1 class="o-form__title">Profil utilisateur</h1>
                <!-- <div class="o-form__item full-width">
                    <Input
                        v-model="form.name"
                        placeholder="Nom"
                        label="Nom"
                        required=true
                        error-message="Ce champ est requis"
                        :filled="false"
                        dense
                        :outlined="true"
                    />
                </div> -->
                <div class="o-form__item">
                    <Input
                        v-model="form.first_name"
                        placeholder="Prénom"
                        label="Prénom"
                        required=true
                        error-message="Ce champ est requis"
                        :filled="false"
                        dense
                        :outlined="true"
                    />
                </div>
                <div class="o-form__item">
                    <Input
                        v-model="form.last_name"
                        placeholder="Nom de famille"
                        label="Nom de famille"
                        required=true
                        error-message="Ce champ est requis"
                        :filled="false"
                        dense
                        :outlined="true"
                    />
                </div>
                <div class="o-form__item q-mb-lg">
                    <Input
                        type="email"
                        v-model="form.email"
                        placeholder="Email"
                        label="Courriel"
                        required=true
                        error-message="Ce champ est requis"
                        :filled="false"
                        dense
                        :outlined="true"
                    />
                </div>
                <div class="o-form__item">
                    <Input
                        v-model="form.phone_work"
                        placeholder="(111) 111-1111"
                        label="Téléphone (travail)"
                        required=true
                        error-message="Ce champ est requis"
                        :filled="false"
                        dense
                        :outlined="true"
                     />
                </div>
                <div class="o-form__item">
                    <Input
                        v-model="form.phone_home"
                        placeholder="(111) 111-1111"
                        label="Téléphone (maison)"
                        :filled="false"
                        dense
                        :outlined="true"
                     />
                </div>
                <div class="o-form__item">
                    <Input
                        v-model="form.phone_mobile"
                        placeholder="(111) 111-1111"
                        label="Téléphone (mobile)"
                        :filled="false"
                        dense
                        :outlined="true"
                     />
                </div>
                <div class="o-form__item q-mb-lg">
                </div>
                <div class="o-form__item">
                    <Input
                        v-model="form.street"
                        placeholder="Rue"
                        label="Adresse"
                        :filled="false"
                        dense
                        :outlined="true"
                    />
                </div>
                <div class="o-form__item">
                    <Input
                        v-model="form.town"
                        placeholder="Ville"
                        label="Ville"
                        :filled="false"
                        dense
                        :outlined="true"
                    />
                </div>
                <div class="o-form__item">
                    <Input
                        v-model="form.state"
                        placeholder="ex. Qc"
                        label="Province"
                        :filled="false"
                        dense
                        :outlined="true"
                    />
                </div>
                <div class="o-form__item">
                    <Input
                        v-model="form.country"
                        placeholder="Country"
                        label="Pays"
                        :filled="false"
                        dense
                        :outlined="true"
                    />
                </div>
                <div class="o-form__item">
                    <Input
                        v-model="form.zipcode"
                        placeholder="ex. A1A 1A1"
                        label="Code postal"
                        :filled="false"
                        dense
                        :outlined="true"
                    />
                </div>
                
                <div class="o-form__item">
                    <q-item tag="label">
                        <q-item-section side style="justify-content: start">
                            <q-checkbox size="xs" dense v-model="form.recover_navigation" />
                        </q-item-section>
                        <q-item-section>
                            <q-item-label style="font-size: 12px; font-weight: 600;">Reprendre la navigation</q-item-label>
                            <q-item-label caption>Récupérer l'interface à partir de la dernière date affichée. Si cette option est désactivée, la navigation reprendra à la date du jour</q-item-label>
                        </q-item-section>
                    </q-item>
                </div>

                <!-- <div class="o-form__item">
                    <Select
                        :options="companies.data"
                        placeholder="Choisir une compagnie"
                        label="Compagnie"
                        v-model="form.company"
                        :clearable="false"
                        :filled="false"
                        dense
                        :outlined="true"
                    />
                </div> -->
                <div class="o-form__item -button">
                    <button type="submit" class="o-button -lg" :loading="$apollo.loading" color="primary">
                        Sauvegarder
                        <q-icon name="save" class="o-ico -right" />    
                    </button>
                </div>
            </fieldset>
        </form>
    </div>
</template>

<script>
    import { UPDATEMYUSERPROFILE } from '@/graphql/user/mutations'
    import { MYPROFILE } from '@/graphql/user/queries'
    import { COMPANIES } from '@/graphql/company/queries'
    import { removeNULL } from '@/js/utilities'


    export default {
        name: 'myUserProfile',
        props: {
            isMobile: {
                type: Boolean,
                default: false
            },
        },
        apollo: {
            myProfile: {
                query: MYPROFILE,
                fetchPolicy: 'cache-first',
                error(error){
                    if (error.message) this.$q.notify({type: 'negative', message: "Oh Oh", caption: error.message});
                },
                update(myProfile) {
                    this.form = Object.assign({}, myProfile.myProfile);
                    return myProfile
                }
            },
            companies: {
                query: COMPANIES,
                fetchPolicy: 'cache-first',
                error(error){
                    if (error.message) this.$q.notify({type: 'negative', message: "Oh Oh", caption: error.message});
                },
            }
        },
        data(){
            return {
                selectedCompany: 'Choisir une compagnie',
                form: {},
            }
        },
        methods: {
            async updateMyUserProfile(updateMyUserProfileDetails){
                updateMyUserProfileDetails = removeNULL(updateMyUserProfileDetails);
                updateMyUserProfileDetails.company_id=updateMyUserProfileDetails.company.id
                await this.$apollo.mutate({
                    mutation: UPDATEMYUSERPROFILE,
                    variables: { ...updateMyUserProfileDetails }
                }).then(() => {
                    this.$q.notify({type: 'positive', message: "Compte : "+updateMyUserProfileDetails.name, caption: "Informations sauvegardées"})
                }).catch(e => {
                    if (e.message) this.$q.notify({type: 'negative', message: "Oh Oh", caption: e.message})
                }).finally(() => {
                })
            },
        }
    }
</script>
<style lang="scss" scoped>
    // .form-wrapper {
    // }
</style>
